// extracted by mini-css-extract-plugin
export default {"label":"form-field-label_label__hSSeR","label--no-left-margin":"form-field-label_label--no-left-margin__bUINY"};